import { connect } from 'react-redux';

import { getAssignment } from '../../../actions/student-assignments';
import {
  createOrUpdateSubmission, getAssignmentSubmission,
  deleteSubmissionFile
} from '../../../actions/student-submissions';
import { formApiAction } from '../../../actions/api';
import { submissionFilesSelector } from '../../../selectors/submission-files';
import SubmissionCreate from './submission-create';
import { toggleSubmissionJoyride } from '../../../actions/ui';

const mapStateToProps = (state) => ({
  submissionCreated: state.submissions.submissionCreated,
});

const mapDispatchToProps = (dispatch) => {
  const formCreateOrUpdateSubmission = formApiAction(createOrUpdateSubmission);
  return {
    createOrUpdateSubmission: (formData, setError) => {
      dispatch(formCreateOrUpdateSubmission(formData, setError));
    },
    toggleSubmissionJoyride: () => dispatch(toggleSubmissionJoyride()),
    deleteSubmissionFile: (id) => dispatch(deleteSubmissionFile(id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubmissionCreate);
